import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IPDFDocumentDto } from 'core/dto';
import { DocumentCollectionService } from './document-collection.service';

@Component({
  selector: 'ss-document-collection',
  templateUrl: './document-collection.component.html',
  styleUrls: ['./document-collection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentCollectionComponent implements OnInit {


  readonly pdfDocumentsSubject = this._documentCollectionService.pdfDocumentsSubject;
  readonly pdfDocumentsGroupedObs = this._documentCollectionService.pdfDocumentsGroupedObs;

  constructor(
    private _documentCollectionService: DocumentCollectionService
  ) { }

  ngOnInit(): void {

  }

  documentDrop(evParams: CdkDragDrop<any>) {
    const { currentIndex, previousIndex } = evParams;
    this._documentCollectionService.reorder({ currentIndex, previousIndex })
  }

  trackById(idx: number, pdfDocument: IPDFDocumentDto) {
    return 'pdf-document-' + pdfDocument.id;
  }

  trackByIdx(idx: number) {
    return idx;
  }
}
